import React, { useState, useRef, useEffect } from "react";
import { Auth, API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import { Button, Form, Col, Modal, Tabs, Tab, Row } from "react-bootstrap";
// import Moment from 'react-moment';
import { Images } from "../../components";
import "./style.sass";
import { v4 } from "uuid";
import { validateDate, validateEmail, validateName, validatePassword, validatePhone } from "../../common/validation";
import { listCompanies } from "../../api/queries";

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signupFormValidation, setSignupFormValidation] = useState(false);
  const [verificationValidated, setVerificationValidated] = useState(false);
  const [recentRegister, setRecentRegister] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [studentDateOfBirth, setStudentDateOfBirth] = useState("");
  const [studentGender, setStudentGender] = useState("");
  const [studentNotes, setStudentNotes] = useState("");
  const [previousSATRWScore, setPreviousSATRWScore] = useState("");
  const [previousMathScore, setPreviousMathScore] = useState("");
  const [targetTestDate, setTargetTestDate] = useState("");
  const [unweightedGPA, setUnweightedGPA] = useState("");
  const [weightedGPA, setWeightedGPA] = useState("");
  const [companyName, setCompanyName] = useState("BEEC");
  const [selectedCompany, setSelectedCompany] = useState(
    "c3b4f8f0-4278-4753-b7a6-fe6327db4fa3"
  );
  const [userType, setUserType] = useState("STUDENT");
  const [noGuardian, setNoGuardian] = useState(true);
  const [guardianFirstName, setGuardianFirstName] = useState("");
  const [guardianLastName, setGuardianLastName] = useState("");
  const [guardianRelation, setGuardianRelation] = useState("");
  const [guardianPhone, setGuardianPhone] = useState("");
  const [guardianEmail, setGuardianEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [school, setSchool] = useState("");
  const [grade, setGrade] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [code, setCode] = useState("");
  const [showVerification, setShowVerification] = useState(false);
  const [signupFieldValidation, setSignupFieldValidation] = useState({});
  const [canSubmit, setCanSubmit] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState("");
  const [isCustomSchool, setIsCustomSchool] = useState(false);
  const [customSchoolName, setCustomSchoolName] = useState("");
  const [schoolSearchTerm, setSchoolSearchTerm] = useState("");
  const [showSchoolDropdown, setShowSchoolDropdown] = useState(false);
  const schoolDropdownRef = useRef(null);
  useEffect(() => {
    if (noGuardian) {
      setSignupFieldValidation({
        firstName: false,
        lastName: false,
        username: false,
        school: false,
        grade: false,
        dob: false,
        gender: false,
        phone: false,
        companyId: false,
        password: false,
        confirmPassword: false,
      });
    } else {
      setSignupFieldValidation({
        firstName: false,
        lastName: false,
        username: false,
        school: false,
        grade: false,
        dob: false,
        gender: false,
        phone: false,
        companyId: false,
        password: false,
        confirmPassword: false,
        guardianFirstName: false,
        guardianLastName: false,
        guardianEmail: false,
        guardianPhone: false,
        guardianRelation: false,
      });
    }
  }, [noGuardian]);

  useEffect(() => {
  //  if(Object.keys(signupFieldValidation).some(k => signupFieldValidation[k])) {
  //     setCanSubmit(false);
  //   }
    const hasFalseStatus = Object.keys(signupFieldValidation).some(k => signupFieldValidation[k]);
    if(!hasFalseStatus) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
    }
  }, [signupFieldValidation]);

  // Fetch companies list on component mount
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const result = await API.graphql({
          query: listCompanies,
          variables: {
            limit: 1000
          },
          authMode: GRAPHQL_AUTH_MODE.API_KEY
        });
        if (result.data?.listCompanies?.items) {
          const sortedItems = result.data.listCompanies.items.sort((a, b) => {
            const nameA = a.name || "";
            const nameB = b.name || "";
            return nameA.localeCompare(nameB);
          });
          setCompanies(sortedItems);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };
    fetchCompanies();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (schoolDropdownRef.current && !schoolDropdownRef.current.contains(event.target)) {
        setShowSchoolDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter companies based on search term
  const filteredCompanies = companies.filter((company) =>
    company.name?.toLowerCase().includes(schoolSearchTerm.toLowerCase())
  );

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const form = event.currentTarget;
  //   if (form.checkValidity() === false) {
  //     event.stopPropagation();
  //   } else {
  //     if (password !== passwordConfirm) {
  //       toast.error("Password must match with confirm password");
  //     } else {
  //       try {
  //         const { user } = await Auth.signUp({
  //           username: v4(),
  //           password,
  //           attributes: {
  //             email: username,
  //             given_name: firstName,
  //             family_name: lastName,
  //             profile: "TEACHER",
  //           },
  //         });
  //         if (user) {
  //           toast.success("A code has been sent to " + username);
  //           console.log("Recent register user is ", user);
  //           setRecentRegister(user);
  //           setShowVerification(true);
  //         }
  //       } catch (error) {
  //         toast.error(error.message);
  //       }
  //     }
  //     setSignupFormValidation(true);
  //   }
  // };

  const getTodayYMD = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const isValidYMDDateString = (value) => {
    const exact = (value || "").trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(exact)) return false;
    const [yStr, mStr, dStr] = exact.split("-");
    const y = Number(yStr);
    const m = Number(mStr);
    const d = Number(dStr);
    const date = new Date(`${exact}T00:00:00`);
    if (Number.isNaN(date.getTime())) return false;
    return (
      date.getFullYear() === y &&
      date.getMonth() + 1 === m &&
      date.getDate() === d
    );
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    } else {
      if (password !== passwordConfirm) {
        return toast.error("Password must match with confirm password");
      } else {
        if (noGuardian) {
          if(firstName === "" || lastName === "" || username === "" || phoneNo === "" || school === "" || grade === "" || studentDateOfBirth === "" || studentGender === "") {
            return toast.error("All fields are required");
          }  
        } else if(!noGuardian) {
          if(firstName === "" || lastName === "" || username === "" || phoneNo === "" || school === "" || grade === "" || studentDateOfBirth === "" || studentGender === "" || guardianFirstName === "" || guardianLastName === "" || guardianEmail === "" || guardianPhone === "" || guardianRelation === "") {
            return toast.error("All fields are required");
          }
        }
        let userData = {
          firstName: firstName,
          lastName: lastName,
          email: username,
          phone: phoneNo,
          companyId: selectedCompany,
          password: password,
        };
        const parent = {};

        if (userType === "STUDENT") {
          userData.school = school;
          userData.grade = grade;
          userData.dob = studentDateOfBirth;
          userData.gender = studentGender;
          userData.notes = studentNotes;
          if (previousSATRWScore) userData.previousSATRWScore = previousSATRWScore;
          if (previousMathScore) userData.previousMathScore = previousMathScore;
          if (targetTestDate) {
            const todayYMD = getTodayYMD();
            if (!isValidYMDDateString(targetTestDate)) {
              return toast.error("Target Test Date is invalid");
            }
            if (targetTestDate < todayYMD) {
              return toast.error("Target Test Date must be today or later");
            }
            userData.targetTestDate = targetTestDate;
          }
          if (unweightedGPA) userData.unweightedGPA = unweightedGPA;
          if (weightedGPA) userData.weightedGPA = weightedGPA;

          if (!noGuardian) {
            parent.firstName = guardianFirstName;
            parent.lastName = guardianLastName;
            parent.email = guardianEmail;
            parent.phone = guardianPhone;
            parent.relation = guardianRelation;
          }
        }
        if (!noGuardian) {
          console.log("I am no guardian=false");
          dispatch(Actions.dispatchCreateUser(userData, parent, "SIGNUP"))
            .then((res) => {
              const parsedResponse = JSON.parse(res);
              if (parsedResponse.statusCode === 200) {
                toast.success(
                  "Verification email have been sent to your " + username
                );
                console.log("Parsed json ", parsedResponse);
                setRecentRegister({
                  username: parsedResponse?.body?.data?.Username,
                });
                setTimeout(() => {
                  navigate('/login')
                }, 5000)
                // setShowVerification(true);
              } else {
                toast.error(parsedResponse?.body?.message);
              }
            })
            .catch((err) => {
              console.log("Error in creating user : ", err);
            });
        } else {
          console.log("I am no guardiannn");

          dispatch(Actions.dispatchCreateUser(userData, null, "SIGNUP"))
            .then((res) => {
              console.log("SIGNUP SUCCESS", JSON.parse(res));
              const parsedResponse = JSON.parse(res);
              if (parsedResponse.statusCode === 200) {
                // toast.success("A code has been sent to " + username);
                toast.success(
                  "Verification email have been sent to your " + username
                );
                setRecentRegister({
                  username: parsedResponse?.body?.data?.Username,
                });
                setTimeout(() => {
                  navigate('/login')
                }, 5000)
                // setShowVerification(true);
              } else {
                toast.error(parsedResponse?.body?.message);
              }

              // dispatch(Actions.listAllUsersAction())
              // navigate('/users')
            })
            .catch((err) => {
              console.log("Error in creating user : ", err);
            });
        }
      }
      setSignupFormValidation(true);
    }
  };

  const submitVerification = async (event) => {
    // if (code === "" || typeof code === "undefined" || code === null) {
    //   return toast.error("Please enter the code");
    // }

    // console.log("Event is ", event);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        const user = await Auth.confirmSignUp(recentRegister.username, code, {
          forceAliasCreation: true,
        });
        if (user === "SUCCESS") {
          toast.success("You have successfully registered");
          // dispatch(Actions.dispatchUserData(recentRegister));
          navigate("/login");
        }
      } catch (error) {
        console.log("error in verification: ", error);
        toast.error(error.message);
      }
    }
    setVerificationValidated(true);
  };

  const resendVerificationEmail = async () => {
    try {
      const email = (username || "").trim();
      if (!email) {
        toast.error("Missing email");
        return;
      }
      await API.post('beecSquare', '/auth/resend-signup', {
        headers: { 'Content-Type': 'application/json' },
        body: { email },
      });
      toast.success("Code resent successfully");
    } catch (err) {
      toast.error("Failed to resend code");
      console.log("error resending code: ", err);
    }
  };

  return (
    <div className="signup-screen">
      {/* top nav bar */}
      {/* <Header /> */}
      {/* signup section */}
      <div className="signup-section">
        <div className="col-lg-10 col-xl-8 col-md-11 col-11 mx-auto py-5">
          <div className="row mx-0 signup-inner registration-inner">
            <div className="col-xxl-5 col-md-6 py-4 py-md-0">
              <div className="d-flex align-items-center">
                <div className="w-100 py-5 registration-form">
                  <div className="px-3">
                    <h3 className="heading-3 mb-1">Create your account</h3>
                    <p className="signup-summary body-1">
                      All Fields must be filled unless marked (Optional)
                    </p>
                  </div>
                  <div className="signup-user-selection px-3">
                    {/* <p className="signup-summary body-1">
                      <i>Signup as a:</i>
                    </p> */}
                    {/* <Tabs
                      id="select-user-type"
                      variant="pills"
                      activeKey={userType}
                      onSelect={(k) => setUserType(k)}
                      className="mb-3"
                    >
                      <Tab eventKey="STUDENT" title="Student"></Tab>
                      <Tab eventKey="PARENT" title="Parent"></Tab>
                    </Tabs> */}
                  </div>
                  <Form
                    className="px-3 registration-form newRegForm"
                    noValidate
                    validated={signupFormValidation}
                    onSubmit={(e) => handleSubmit(e)}
                  >
                    {userType === "STUDENT" && (
                      <Form.Check className="d-none">
                        <Form.Check.Input
                          type="checkbox"
                          className="signup-checkbox"
                          id="no-guardian"
                          checked={noGuardian}
                          onChange={(e) => setNoGuardian(e.target.checked)}
                        />
                        <Form.Check.Label
                          htmlFor="no-guardian"
                          className="signup-labels body-2"
                        >
                          Student is account holder, no guardian required
                        </Form.Check.Label>
                      </Form.Check>
                    )}
                    <Form.Group
                      className={
                        signupFieldValidation.firstName
                          ? "input-wrapper"
                          : "input-wrapper"
                      }
                      as={Col}
                      md="12"
                      controlId="firstName"
                    >
                      <Form.Label className="signup-labels body-2">
                        First Name <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="text"
                        placeholder="First Name"
                        required
                        value={firstName}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                          validateName(e.target.value).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                firstName: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                firstName: true,
                              });
                            }
                          });
                        }}
                        onFocus={(e) => {
                          validateName(firstName).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                firstName: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                firstName: true,
                              });
                            }
                          });
                        }}
                      />
                      {signupFieldValidation.firstName && (
                        <span className="text-danger input-error-message">
                          Please enter your first name
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="last name"
                    >
                      <Form.Label className="signup-labels body-2">
                        Last Name <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="text"
                        placeholder="Last Name"
                        required
                        value={lastName}
                        onChange={(e) => {
                          setLastName(e.target.value);
                          validateName(e.target.value).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                lastName: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                lastName: true,
                              });
                            }
                          });
                        }}
                        onFocus={(e) => {
                          validateName(lastName).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                lastName: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                lastName: true,
                              });
                            }
                          });
                        }}
                      />
                      {signupFieldValidation.lastName && (
                        <span className="text-danger input-error-message">
                          Please enter your last name
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="email address"
                    >
                      <Form.Label className="signup-labels body-2">
                        Email Address <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="email"
                        placeholder="Email Address"
                        required
                        value={username}
                        onChange={(e) => {
                          setUsername(e.target.value);
                          validateEmail(e.target.value).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                username: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                username: true,
                              });
                            }
                          });
                        }}
                        onFocus={(e) => {
                          validateEmail(username).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                username: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                username: true,
                              });
                            }
                          });
                        }}
                      />
                      {signupFieldValidation.username && (
                        <span className="text-danger input-error-message">
                          Please enter your email
                        </span>
                      )}
                    </Form.Group>
                    {userType === "STUDENT" && (
                      <>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="school"
                        >
                          <Form.Label className="signup-labels body-2">
                            School Name <span className="">*</span>
                          </Form.Label>
                          <div ref={schoolDropdownRef} style={{ position: "relative" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #ced4da",
                                borderRadius: "0.25rem",
                                backgroundColor: "white",
                                cursor: "pointer",
                                padding: "0.375rem 0.75rem",
                                minHeight: "38px",
                              }}
                              onClick={() => {
                                setShowSchoolDropdown(!showSchoolDropdown);
                              }}
                            >
                              <span
                                className="body-2"
                                style={{
                                  flex: 1,
                                  color: selectedSchoolId || isCustomSchool ? "#212529" : "#6c757d",
                                }}
                              >
                                {isCustomSchool
                                  ? "Custom"
                                  : selectedSchoolId
                                  ? companies.find((c) => c.id === selectedSchoolId)?.name || "Select a school"
                                  : "Select a school"}
                              </span>
                              <span style={{ marginLeft: "8px", color: "#6c757d" }}>
                                {showSchoolDropdown ? "▲" : "▼"}
                              </span>
                            </div>
                            {showSchoolDropdown && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  backgroundColor: "white",
                                  border: "1px solid #ced4da",
                                  borderRadius: "0.25rem",
                                  marginTop: "4px",
                                  maxHeight: "300px",
                                  overflow: "hidden",
                                  zIndex: 1000,
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                }}
                              >
                                <div style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                                  <Form.Control
                                    autoComplete="off"
                                    type="text"
                                    placeholder="Search schools..."
                                    value={schoolSearchTerm}
                                    onChange={(e) => {
                                      setSchoolSearchTerm(e.target.value);
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    style={{
                                      fontSize: "14px",
                                      padding: "6px 12px",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {filteredCompanies.length > 0 ? (
                                    filteredCompanies.map((company) => (
                                      <div
                                        key={company.id}
                                        style={{
                                          padding: "10px 12px",
                                          cursor: "pointer",
                                          borderBottom: "1px solid #f0f0f0",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.backgroundColor = "#f8f9fa";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.backgroundColor = "white";
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedSchoolId(company.id);
                                          setSchool(company.name);
                                          setSchoolSearchTerm("");
                                          setShowSchoolDropdown(false);
                                          setIsCustomSchool(false);
                                          setCustomSchoolName("");
                                          setSignupFieldValidation({
                                            ...signupFieldValidation,
                                            school: false,
                                          });
                                        }}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {company.name}
                                      </div>
                                    ))
                                  ) : schoolSearchTerm !== "" ? (
                                    <div
                                      style={{
                                        padding: "12px",
                                        color: "#6c757d",
                                        textAlign: "center",
                                      }}
                                    >
                                      No schools found
                                    </div>
                                  ) : null}
                                </div>
                                <div
                                  style={{
                                    padding: "10px 12px",
                                    cursor: "pointer",
                                    borderTop: "1px solid #f0f0f0",
                                    backgroundColor: "#f8f9fa",
                                    fontWeight: "500",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = "#e9ecef";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "#f8f9fa";
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsCustomSchool(true);
                                    setSelectedSchoolId("");
                                    setSchool("");
                                    setSchoolSearchTerm("");
                                    setShowSchoolDropdown(false);
                                    setCustomSchoolName("");
                                    setSignupFieldValidation({
                                      ...signupFieldValidation,
                                      school: true,
                                    });
                                  }}
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  Custom
                                </div>
                              </div>
                            )}
                          </div>
                          {isCustomSchool && (
                            <Form.Control
                              autoComplete="off"
                              className="signup-input body-2 mt-2"
                              type="text"
                              placeholder="Enter school name"
                              required
                              value={customSchoolName}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                setCustomSchoolName(newValue);
                                setSchool(newValue);
                                if (newValue === "") {
                                  setSignupFieldValidation({
                                    ...signupFieldValidation,
                                    school: true,
                                  });
                                } else {
                                  setSignupFieldValidation({
                                    ...signupFieldValidation,
                                    school: false,
                                  });
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value === "") {
                                  setSignupFieldValidation({
                                    ...signupFieldValidation,
                                    school: true,
                                  });
                                } else {
                                  setSignupFieldValidation({
                                    ...signupFieldValidation,
                                    school: false,
                                  });
                                }
                              }}
                            />
                          )}
                          {signupFieldValidation.school && (
                            <span className="text-danger input-error-message">
                              Please select or enter your school name
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="grade"
                        >
                          <Form.Label className="signup-labels body-2">
                            Grade <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="text"
                            placeholder="Grade"
                            required
                            value={grade}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setGrade(newValue);
                              if (newValue === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  grade: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  grade: false,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              if (e.target.value === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  grade: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  grade: false,
                                });
                              }
                            }}
                          />
                          {signupFieldValidation.grade && (
                            <span className="text-danger input-error-message">
                              Please enter your grade
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="date of birth"
                        >
                          <Form.Label className="signup-labels body-2">
                            Date of Birth <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="date"
                            placeholder="Date of Birth"
                            required
                            value={studentDateOfBirth}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setStudentDateOfBirth(newValue);
                              if (newValue === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  dob: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  dob: false,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              if (e.target.value === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  dob: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  dob: false,
                                });
                              }
                            }}
                          />
                          {signupFieldValidation.dob && (
                            <span className="text-danger input-error-message">
                              Please enter your date of birth
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="gender"
                        >
                          <Form.Label className="signup-labels body-2">
                            Gender <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            as="select"
                            required
                            value={studentGender}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setStudentGender(newValue);
                              if (newValue === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  gender: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  gender: false,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              if (e.target.value === "") {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  gender: true,
                                });
                              } else {
                                setSignupFieldValidation({
                                  ...signupFieldValidation,
                                  gender: false,
                                });
                              }
                            }}
                          >
                            <option value="" selected disabled>
                              Choose Gender
                            </option>
                            <option value="BOY">Male</option>
                            <option value="GIRL">Female</option>
                            <option value="NA">Prefer not to say</option>
                          </Form.Control>
                          {signupFieldValidation.gender && (
                            <span className="text-danger input-error-message">
                              Please select your gender
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group className="input-wrapper" as={Col} md="12" controlId="previousSAT">
                          <Form.Label className="signup-labels body-2">
                            Previous SAT Scores 
                          </Form.Label>
                          <Row className="gx-2">
                            <Col xs={6}>
                              <Form.Control
                                autoComplete="off"
                                className="signup-input body-2"
                                type="text"
                                placeholder="R/W"
                                value={previousSATRWScore}
                                onChange={(e) => setPreviousSATRWScore(e.target.value)}
                              />
                            </Col>
                            <Col xs={6}>
                              <Form.Control
                                autoComplete="off"
                                className="signup-input body-2"
                                type="text"
                                placeholder="Math"
                                value={previousMathScore}
                                onChange={(e) => setPreviousMathScore(e.target.value)}
                              />
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group className="input-wrapper" as={Col} md="12" controlId="targetTestDate">
                          <Form.Label className="signup-labels body-2">
                            Target Test Date 
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="date"
                            value={targetTestDate}
                            onChange={(e) => setTargetTestDate(e.target.value)}
                            min={getTodayYMD()}
                          />
                        </Form.Group>
                        <Form.Group className="input-wrapper" as={Col} md="12" controlId="unweightedGPA">
                          <Form.Label className="signup-labels body-2">
                            Unweighted GPA 
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            as="select"
                            value={unweightedGPA}
                            onChange={(e) => setUnweightedGPA(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="2.0-2.5">2.0-2.5</option>
                            <option value="2.6-3.0">2.6-3.0</option>
                            <option value="3.1-3.5">3.1-3.5</option>
                            <option value="3.6-4.0">3.6-4.0</option>
                            <option value="4.1-4.5">4.1-4.5</option>
                            <option value="4.6-5.0">4.6-5.0</option>
                          </Form.Control>
                        </Form.Group>
                        <Form.Group className="input-wrapper" as={Col} md="12" controlId="weightedGPA">
                          <Form.Label className="signup-labels body-2">
                            Weighted GPA 
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            as="select"
                            value={weightedGPA}
                            onChange={(e) => setWeightedGPA(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="2.0-2.5">2.0-2.5</option>
                            <option value="2.6-3.0">2.6-3.0</option>
                            <option value="3.1-3.5">3.1-3.5</option>
                            <option value="3.6-4.0">3.6-4.0</option>
                            <option value="4.1-4.5">4.1-4.5</option>
                            <option value="4.6-5.0">4.6-5.0</option>
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                    {userType === "STUDENT" && !noGuardian && (
                      <>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="guardianFirstName"
                        >
                          <Form.Label className="signup-labels body-2">
                            Guardian First Name <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="text"
                            placeholder="Guardian First Name"
                            required
                            value={guardianFirstName}
                            onChange={(e) =>
                              setGuardianFirstName(e.target.value)
                            }
                          />
                          {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="guardianLastName"
                        >
                          <Form.Label className="signup-labels body-2">
                            Guardian Last Name <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="text"
                            placeholder="Guardian Last Name"
                            required
                            value={guardianLastName}
                            onChange={(e) =>
                              setGuardianLastName(e.target.value)
                            }
                          />
                          {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="guardianEmail"
                        >
                          <Form.Label className="signup-labels body-2">
                            Guardian Email <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="text"
                            placeholder="Guardian Email"
                            required
                            value={guardianEmail}
                            onChange={(e) => setGuardianEmail(e.target.value)}
                          />
                          {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="guardianPhoneNo"
                        >
                          <Form.Label className="signup-labels body-2">
                            Guardian Phone Number <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="tel"
                            placeholder="Guardian Phone Number"
                            required
                            value={guardianPhone}
                            onChange={(e) => setGuardianPhone(e.target.value)}
                          />
                          {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group
                          className="input-wrapper"
                          as={Col}
                          md="12"
                          controlId="guardianRelation"
                        >
                          <Form.Label className="signup-labels body-2">
                            Guardian Relation to Student{" "}
                            <span className="">*</span>
                          </Form.Label>
                          <Form.Control
                            autoComplete="off"
                            className="signup-input body-2"
                            type="text"
                            placeholder="Guardian Relation to Student"
                            required
                            value={guardianRelation}
                            onChange={(e) =>
                              setGuardianRelation(e.target.value)
                            }
                          />
                          {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                        </Form.Group>
                      </>
                    )}
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="phoneNo"
                    >
                      <Form.Label className="signup-labels body-2">
                        Phone Number <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="text"
                        placeholder="Phone Number"
                        required
                        value={phoneNo}
                        onChange={(e) => {
                          setPhoneNo(e.target.value);
                          validatePhone(e.target.value).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                phone: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                phone: true,
                              });
                            }
                          });
                        }}
                        onFocus={(e) => {
                          validatePhone(phoneNo).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                phone: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                phone: true,
                              });
                            }
                          });
                        }}
                      />
                      {signupFieldValidation.phone && (
                        <span className="text-danger input-error-message">
                          Please enter your phone number
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="password"
                    >
                      <Form.Label className="signup-labels body-2">
                        Password <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="password"
                        placeholder="Password"
                        required
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          validatePassword(e.target.value).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                password: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                password: true,
                              });
                            }
                          });
                        }}
                        onFocus={(e) => {
                          validatePassword(password).then((res) => {
                            if (res) {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                password: false,
                              });
                            } else {
                              setSignupFieldValidation({
                                ...signupFieldValidation,
                                password: true,
                              });
                            }
                          });
                        }}
                      />
                      {signupFieldValidation.password && (
                        <span className="text-danger input-error-message">
                          Password must be at least 6 character including one uppercase letter, one lowercase letter
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="confirm password"
                    >
                      <Form.Label className="signup-labels body-2">
                        Confirm Password <span className="">*</span>
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="password"
                        placeholder="Confirm Password"
                        required
                        value={passwordConfirm}
                        onChange={(e) => {
                          setPasswordConfirm(e.target.value);
                          if(e.target.value === password){
                            setSignupFieldValidation({
                              ...signupFieldValidation,
                              confirmPassword: false,
                            });
                          } else {
                            setSignupFieldValidation({
                              ...signupFieldValidation,
                              confirmPassword: true,
                            });
                          }
                        }}
                        onFocus={(e) => {
                          if(passwordConfirm === password && passwordConfirm !== ""){
                            setSignupFieldValidation({
                              ...signupFieldValidation,
                              confirmPassword: false,
                            });
                          } else {
                            setSignupFieldValidation({
                              ...signupFieldValidation,
                              confirmPassword: true,
                            });
                          }
                        }}
                      />
                      {signupFieldValidation.confirmPassword && (
                        <span className="text-danger input-error-message">
                          Password must be at matched
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="input-wrapper"
                      as={Col}
                      md="12"
                      controlId="notes"
                    >
                      <Form.Label className="signup-labels body-2">
                        Notes
                        {/* <span className="">*</span> */}
                      </Form.Label>
                      <Form.Control
                        autoComplete="off"
                        className="signup-input body-2"
                        type="text"
                        placeholder="Enter Notes"
                        value={studentNotes}
                        onChange={(e) => setStudentNotes(e.target.value)}
                      />
                      {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                    </Form.Group>
                    <Form.Group className="input-wrapper mt-4" as={Col} md="12">
                      <Button type="submit" className="blue-button w-100"  disabled={!canSubmit}>
                        Sign Up
                      </Button>
                    </Form.Group>
                    <div>
                      Already have an account?{" "}
                      <a
                        className="login-text"
                        onClick={() => navigate("/login")}
                      >
                        Log in
                      </a>
                    </div>
                    {/* <Form.Group className="input-wrapper mt-4" as={Col} md="12">
                      <Button
                        href="#"
                        onClick={() => navigate("/login")}
                        className="blue-button-outline w-100"
                      >
                        Login
                      </Button>
                    </Form.Group> */}
                  </Form>
                </div>
              </div>
            </div>
            <div className="col-xxl-7 col-md-6 pe-0 d-none d-md-block">
              <img
                src={Images.signup}
                alt="signup"
                className="img-fluid registration-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* footer section */}
      {/* <Footer /> */}
      <Modal
        show={showVerification}
        onHide={() => showVerification(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Form
          className="px-3 registration-form newRegForm"
          noValidate
          validated={verificationValidated}
          onSubmit={(e) => submitVerification(e)}
        >

          <Modal.Body>
            <Form.Group
              className="input-wrapper"
              as={Col}
              md="12"
              controlId="verification code"
            >
              <Form.Label className="signup-labels body-2">
                Confirmation Code <span className="">*</span>
              </Form.Label>
              <Form.Control
                autoComplete="off"
                className="signup-input body-2"
                type="text"
                placeholder="Enter Code Here"
                required
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" className="blue-button">
              Submit
            </Button>
            <Button
              onClick={() => resendVerificationEmail()}
              className="blue-button"
            >
              Resend Code
            </Button>
            <Button
              onClick={() => setShowVerification(false)}
              className="blue-button"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Signup;
